import React from "react";
import { lazyRetry } from "../../../helpers";

export default React.lazy(() =>
  lazyRetry(() => import("./equipment-datagrid"), "equipment-page")
);
